module.exports = __webpack_public_path__ + "static/media/download-app.d0558d91.svg";